export default __webpack_public_path__ + "static/EmailDetails-01572ac5bb6578d28953374e83922c5e.png";